import { render, staticRenderFns } from "./Aromas.vue?vue&type=template&id=07fb6e1e"
import script from "./Aromas.vue?vue&type=script&lang=js"
export * from "./Aromas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports